import React, { Component } from "react";

import {PHOENIXVOUCHER}          from "actions/const";

import View                 from "./View.js";

export default class FormContainer extends Component {
  render () {
    let {
      PhoenixVoucher
    } = this.props;

    let {
      formType
    } = PhoenixVoucher;

    switch (formType.toUpperCase()) {
      case "VIEW":
        return <View {...this.props}/>;
      default:
        return "";
    }
  }

  componentWillUnmount () {
    let {
      actions
    } = this.props;

    actions.setValue(
      PHOENIXVOUCHER,
      {
        selectedData: null,
        formType: "",
        formId: "",
        countType: "",

        isLoading: false,
        isExporting: false,
        tableData: [],
        totalCount: 0,
        limit: 10
      }
    );
  }
}



// WEBPACK FOOTER //
// ./components/PhoenixVoucher/FormContainer/index.js